export { default as App } from './App';
export { default as Home } from './Home';

// Paths
export const agenciesPartialURL = '/agencies';
export const overviewPartialURL = '/overview';
export const toolsPartialURL = '/tools';
export const cdbgPartialURL = '/cdbg';
export const violationTypesPartialURL = '/tools/violation-type';
export const entitySectionPartialURL = '/tools/entity-section';
export const agenciesInfoURL = '/agencies/:agency/info';
export const portalConfigurationURL = '/agencies/:agency/portal';
export const workspacesPartialURL = '/agencies/:agency/info/workspaces';
export const overviewInfoURL = '/overview/info';
export const workspacesOverviewPartialURL = '/overview/info/workspaces';
export const workspacesAgencyPartialURL = '/overview/info/workspaces/agency/:agency';
